import { render, staticRenderFns } from "./bible-passage-select.vue?vue&type=template&id=3e29ac99&"
import script from "./bible-passage-select.vue?vue&type=script&lang=js&"
export * from "./bible-passage-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports